import React, { useState, useEffect, useRef } from "react";
import { Formik } from "formik";
import * as Yup from "yup";
import Cookies from "js-cookie";
import { useNavigate } from "react-router-dom";
import api from "../../api/index";
import { getLastUrlSegment } from "../../utils/index";
import { useTranslation } from 'react-i18next';
import { gsap, Elastic } from "gsap/all";
import useDisableBrowserBack from "../hooks/useDisableBrowserBack";
import useReadCookies from "../hooks/useReadCookies";

function Register() {
  useDisableBrowserBack();
  const { t } = useTranslation();
  const navigate = useNavigate();
  const gameId = getLastUrlSegment();
  Cookies.set("game_id", gameId);

  const [footerTopPosition, setFooterTopPosition] = useState(0);
  const mobileContainerRef = useRef(null);

  let { cookiePlayerId, cookieUsername } = useReadCookies();
  cookiePlayerId = cookiePlayerId || 'none';
  cookieUsername = cookieUsername || '';
  let initialValues = { username: cookieUsername };

  const [animation, setAnimation] = useState(null);
  
  const registerGameSchema = Yup.object().shape({
    username: Yup.string()
      .min(3, t("student.nickname.min_length_validation"))
      .max(20, t("student.nickname.max_length_validation"))
      .trim(t("student.nickname.trim_validation"))
      .required(t("student.nickname.required_validation"))
  });

  const handleSubmit = (values, { setSubmitting }) => {
    api.registerPlayer(gameId, cookiePlayerId, values.username).then((response) => {
      if (response.status === 200) {
        const data = response.data;
        if (data.error) {
          alert('allocated user account limit exceeded for the game.');
        } else {
          const params = new URLSearchParams(window.location.search);
          if (params.get('demo') === 'true') {
            Cookies.set("player_id_" + params.get('player'), data.player_id);
            Cookies.set("user_name_" + params.get('player'), data.user_name);
          } else {
            Cookies.set("player_id", data.player_id);
            Cookies.set("user_name", data.user_name);
          }
          Cookies.set("game_id", data.game_id);
          Cookies.set("group_id", data.group_id);

          setTimeout(() => {
            navigate(`/app/game/group/find/${data.game_id}/${data.player_id}${window.location.search}`);
          }, 500);
        }
      }
    });
  };

  const handleBackButton = (e) => {
    e.preventDefault();
    navigate('/app/game/onboard' + window.location.search);
  }

  useEffect(() => {
    const updateResize = (mobileContainerRef) => {
      if (mobileContainerRef) {
        const containerBCR = mobileContainerRef.getBoundingClientRect();
        const appHeight = containerBCR.height;
        let updatedPosition;

        if (window.visualViewport) {
          const visualViewport = window.visualViewport;
          updatedPosition = visualViewport.height + window.scrollY;
          if (visualViewport.height > 1000 || visualViewport.width > 500) {
            updatedPosition = appHeight;
          }
        } else {
          updatedPosition = appHeight;
        }
        setFooterTopPosition(updatedPosition);
      }
    }
    const updateInterval = setInterval(updateResize, 2, mobileContainerRef.current);
    updateResize();
    return () => clearInterval(updateInterval);
  }, [setFooterTopPosition]);

  

  return (
    <div className="mobileContainer backgroundPaper register-screen" ref={mobileContainerRef}>
      <Formik
        initialValues={initialValues}
        onSubmit={handleSubmit}
        validationSchema={registerGameSchema}
        validateOnMount={true}
      >
        {({
          values,
          errors,
          touched,
          handleChange,
          handleBlur,
          handleSubmit,
          isSubmitting,
          isValid
        }) => (
          <form className="game-form" onSubmit={handleSubmit}>
            <div className="form-wrapper">
              <div className='fx-ring-container'>
                <div className='fx-ring'></div>
                <div className='fx-ring-inner'></div>
                <div className='fx-ring-outer'></div>
              </div>
              <h3 className='form-title'>{t("student.nickname.title")}</h3>
              <div className='input-wrapper'>
                <div className='input-background'></div>
                  <input
                    className='big-input'
                    type="text"
                    name="username"
                    autoComplete="off"
                    maxLength="20"
                    placeholder={t("student.nickname.placeholder_text")}
                    value={values.username}
                    onBlur={handleBlur}
                    onChange={handleChange}
                  />
              </div>
              <div className="validation-error">
                <p>
                  {errors.username && touched.username && errors.username}
                </p>
              </div>
              <div className="help speechBalloonSmall">
                <p>{t("student.nickname.help")}</p>
              </div>
            </div>
            <div className={`navigationDrawer formFooter spread variant6 `} style={{top: footerTopPosition}}>
              <a className="chromelessIconButton" onClick={handleBackButton}>
                <span className="icon icon-backward-simple"></span>
              </a>
              <button type="submit" className={`chromelessIconButton ${!isValid || isSubmitting ? 'disabled' : ''}`} disabled={!isValid || isSubmitting}>
                <span className="caption">{t("student.nickname.countinue_button")}</span>
                <span className={`icon ${!isValid || isSubmitting ? 'icon-forward-simple' : 'icon-forward'}`}></span>
              </button>
            </div>
          </form>
        )}
      </Formik>
    </div>
  );
}

export default Register;
